import { GLOCKAPP_DELIVERABILITY_SCORE } from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';

export default class GlockAppController extends AuthenticatedController {
  static async getAccountDeliverabilityScore(
    facebookPageId: number,
    emailAccountId?: number,
  ) {
    return super.get(GLOCKAPP_DELIVERABILITY_SCORE, {
      facebook_page_id: facebookPageId,
      ...(emailAccountId ? { email_account_id: emailAccountId } : ''),
    });
  }

  static async runAccountDeliverabilityScore(
    facebookPageId: number,
    emailAccountId: number,
  ) {
    return super.post(GLOCKAPP_DELIVERABILITY_SCORE, {
      facebook_page_id: facebookPageId,
      email_account_id: emailAccountId,
    });
  }
}
